/* home_seo_body.js — the homepage's indexable body copy.
 *
 * WHY THIS FILE EXISTS (2026-10-11, v60.99.120):
 * The homepage had 3,111 words and 9 H2s in a real browser, but only 346
 * words and 2 H2s before any scroll — every section below the hero sits
 * inside <DeferUntilVisible>, which mounts on IntersectionObserver. Googlebot
 * does not scroll, and the build-time static HTML served to crawlers
 * (static_prerender.js, because the deploy container has no Chrome) contained
 * a 189-word synthetic summary. So Google only ever saw a thin homepage, and
 * the URL was never indexed: an exact-phrase search for its own H1 returned
 * zero results while blog pages (which DO emit full static text) were indexed.
 *
 * This module is the single source of truth for real homepage body copy, and
 * it is consumed TWICE:
 *   1. src/components/landing/HomeSeoBody.jsx renders it EAGERLY (never inside
 *      DeferUntilVisible) so it exists in the DOM at first paint.
 *   2. frontend/scripts/static_prerender.js injects the same text into the
 *      static HTML for "/", so crawlers get it with zero JS execution.
 * Keep the two in sync by editing only home_seo_body.json: this module is a
 * thin re-export so the React build and the CommonJS prerender script can
 * both read the exact same copy (the script cannot import ESM).
 *
 * Keyword targets (from backend/data/keyword_target.json, homepage row):
 *   primary   — "free live traffic widget" (880/mo)
 *   secondary — "live visitor counter free" (1,900/mo),
 *               "free seo tools no signup" (1,300/mo),
 *               "free embeddable widgets for website" (720/mo)
 * Each target owns exactly one H2 below. Do not add a second H2 for the same
 * intent: the homepage already cannibalised itself once.
 */

import HOME_SEO_BODY_JSON from "@/data/home_seo_body.json";

export const HOME_SEO_BODY = HOME_SEO_BODY_JSON;

export default HOME_SEO_BODY;
